import { sportmomentApi } from "~/utils/axios.util";

declare const tokenUnit: string;
declare const _platformId: number;

export interface Actiecode {
    Id: number;
    Code: string;
    Value: number;
    ValueInPercentage: number;
    Meta?: string;
}

export interface Spaarpunt {
    Sportmoment: number | null;
}

class ActiecodeRepository {
    async hasAnyActive(sportmomentId: string): Promise<boolean> {
        const response = await sportmomentApi.get<boolean>("api/actiecode/AnyActive", {
            params: { sportmomentId, Platform: _platformId },
            headers: { Authorization: "Bearer " + tokenUnit },
        });
        return response.data;
    }

    async validateActiecode(code: string, sportmomentId: string): Promise<Actiecode | null> {
        // For BETALING (bekostigingstype 3) always use IsValidForAanbod
        const response = await sportmomentApi.get<Actiecode>("api/actiecode/IsValidForAanbod", {
            params: { code, sportmomentId, Platform: _platformId },
            headers: { Authorization: "Bearer " + tokenUnit },
        });
        return response.data;
    }

    async getSpaarpunten(): Promise<Spaarpunt[]> {
        const response = await sportmomentApi.get<Spaarpunt[]>("api/spaarpunt/getbyprofile", {
            params: { Platform: _platformId },
            headers: { Authorization: "Bearer " + tokenUnit },
        });
        return response.data;
    }
}

export default new ActiecodeRepository();
